module.exports = __webpack_public_path__ + "img/crc-03.753522dc.jpg";